import React, { Component } from 'react';
import { Container, ContainerLarge, Article, Heading, FirstSection, Section, SideColumnLeftLarge, MainColumn, Figure, KeySection } from '../../theme/grid';
import { OverlaySummery } from '../../theme/overlay';
import { HeadingH1, HeadingH2, DropCap, BulletedList } from '../../theme/typography';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import PageFooter from '../../components/PageFooter/PageFooter';
import Editor from '../../assets/Mozilla/ComponentEditor/Editor/Editor';
import { Icon } from '../../theme/assets';
import { Caption } from '../../theme/typography';
import { Overlay, OverlayContainer } from '../../theme/overlay';

const small = require('../../assets/Mozilla/ComponentEditor/mozilla-editor.png');
const medium = require('../../assets/Mozilla/ComponentEditor/mozilla-editor@2x.png');
const large = require('../../assets/Mozilla/ComponentEditor/mozilla-editor@3x.png');

const MozillaIllo = () => (
  <img alt="" src={small} srcSet={`${small} 300w, ${medium} 768w, ${large} 1280w`} />
);

export default class MozillaComponentEditor extends Component {
  static propTypes = {};
  
  constructor(props) {
      super(props)

      this.handler = this.handler.bind(this);

      if (this.props.location.hash == "#present") {
        this.state = {
            messageShown: false
        };
      } else {
        this.state = {
            messageShown: true
        };
      }
  }

  handler() {
      this.setState({
          messageShown: !this.state.messageShown
      });
  }

  render() {
    return (
      <div>
          <Header theme={"mozilla " + this.state.messageShown} color="#FF0900" date="Fall 2018" role="Concept, Design, Development" action={this.handler}></Header>
          <Article className={"mozilla " + this.state.messageShown}>
            <Container className={this.state.messageShown}>
                <Heading className={this.state.messageShown}>
                  <HeadingH2 className="mozilla">Mozilla</HeadingH2>
                  <HeadingH1>Component Editor</HeadingH1>
                  <OverlaySummery className={this.state.messageShown}>
                    <p>I designed the plugin to make it as easy as possible to start working with Mozilla's brand assets.</p>
                    <ul>
                      <li>Imports Layer Styles</li>
                      <li>Interchangable Layer Styles</li>
                      <li>Updates Layer Fills</li>
                    </ul>
                  </OverlaySummery>
                </Heading>
              <FirstSection className={this.state.messageShown}>
                <MainColumn>
                  <p><DropCap>O</DropCap>ne of my main responsibilities at Mozilla was to work on a design system that was meant to be used by multiple teams across marketing and product. I conducted an audit of our existing components and then created a Sketch file where I tried to consolidate those components and create a flexible Sketch library with dozens of styles/ symbols that are designed to be easily updated and overriden.</p>
                  <p>I wanted to bring a similair workflow to the web, so I built a component editor that developers can use to generate the code they need to add a component to a page. This tool helped us cut down on the amount one-off components and made our documentation site easier to work with because we could include every permutations for each component instead of a few key examples.</p>
                </MainColumn>
              </FirstSection>
              <KeySection className={this.state.messageShown}>
                <Editor />
                <Caption><Icon src={require('../../icons/touch-red.gif')} alt="icon"/>Hey, you can try this!</Caption>
              </KeySection>
              <Section className={this.state.messageShown}>
                <MainColumn>
                  <h2>Features</h2>
                  <p>Before creating this tool I spoke with designers, content strategists, and developers. I then built features that would satisfy each one of these groups.</p>
                  <BulletedList>
                    <li>
                      <b>Live Updates</b>
                      <p>As choices are made, both the component and the code sample are updated to reflect these changes.</p>
                    </li>
                    <li>
                      <b>Dynamic Alerts</b>
                      <p>Warning alerts will appear when the recommended word count is exceed or a required phrase hasn't been included.</p>
                    </li>
                    <li>
                      <b>Easy to Implement</b>
                      <p>The component editor is a single javascript file which can be implemented on any page using data-attribute tags.</p>
                    </li>
                  </BulletedList>
                </MainColumn>
                <SideColumnLeftLarge>
                  <MozillaIllo/>
                </SideColumnLeftLarge>
              </Section>
            </Container>
          </Article>
          <PageFooter present={this.state.messageShown} theme="mozilla" leftTitle="Mozilla" left="Design Tokens" leftLink="mozilla-design-tokens" rightTitle="EveryAction" right="Design System" rightLink="everyaction-design-system"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/MozillaComponentEditor/ComponentEditor.js